module.exports = __webpack_public_path__ + "img/SMARTAUTH.8eb80660.png";